export default __webpack_public_path__ + "e43ba18e8e6cc85700135a4defe3447f.svg";